module.exports = __webpack_public_path__ + "static/media/19.68d52f09.gif";